import API from "helpers/api";
import { BASE_API_PATH } from "helpers/constants";

const ENDPOINT = `${BASE_API_PATH}Jobs`;

// Mirrors EMI3APIServer.Models.DTOs.Jobs.JobState. The API serialises this as
// the integer enum value, so we compare numerically.
export const JobState = Object.freeze({
	Pending: 0,
	Processing: 1,
	Succeeded: 2,
	Failed: 3,
	Unknown: 4,
});

const ok = (response) => ({
	status: response?.status >= 200 && response?.status < 300,
	data: response?.data,
});

// GET /api/Jobs/{jobId}/status — returns
//   { jobId, state, message, createdAt, startedAt, completedAt,
//     exceptionType, exceptionMessage, exceptionDetails, result? }
export const getReportJobStatus = async (jobId) => {
	try {
		return ok(await API.get(`${ENDPOINT}/${jobId}/status`));
	} catch (err) {
		return ok(err?.response);
	}
};
